export type TrainingProgramsConfig = {
    id?: string;
    maxTrainings?: number | null;
    applicableLocationsConfig: ApplicableLocationsConfig;
    trainerAppConfig: TrainerAppConfig;
};

export type ApplicableLocationsConfig = {
    enableApplicableLocations: boolean;
};

export type TrainerAppConfig = {
    allowActions: boolean;
    enableTrainerSignature: boolean;
    enableOperatorSignature: boolean;
    enableUploadEvidence: boolean;
    taskTypesWithEvidence: TaskTypeWithEvidence[];
};

export type TaskTypeWithEvidence = {
    taskType: TaskType;
    evidenceRequired: boolean;
};

export enum TaskType {
    PATIENT_TEST = 'PATIENT_TEST',
    OBSERVED_PATIENT_TEST = 'OBSERVED_PATIENT_TEST',
    E_LEARNING = 'E_LEARNING',
    QUALITY_CONTROL = 'QUALITY_CONTROL',
    CUSTOM_MANUAL_TASK = 'CUSTOM_MANUAL_TASK',
}
